import React, { useEffect, useState } from 'react'
import { Accordion, Button, Col, Form, InputGroup, Modal, Row, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import i18next from 'i18next'
import CurrencyInput from 'react-currency-input-field'
import Select from 'react-select'
import { RichText } from 'src/components'
import { getPlant2, getPlantV2, getSloc } from 'src/api/modules/getdatalist'
import swal from 'sweetalert'
import { stat } from 'fs/promises'
import { getListMaterialAll, getMaterialGroup } from 'src/api/modules/master-data/master'
import { ProductType } from '../../si/FormDetailSIP/RowItem'
import { set } from 'date-fns'


interface PropsItem {
    item: any,
    show: boolean,
    onCloseModal(): void,
    onEdit(item: any): void
}

export const ModalEditItem: React.FC<PropsItem> = (props) => {

    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [plants, setPlants] = useState<any[]>([])
    const [slocs, setSlocs] = useState<any[]>([])
    const [product_types, setProductTypes] = useState<any[]>([])
    const [products, setProducts] = useState<any[]>([])

    const [sector, setSector] = useState('')
    const [plant, setPlant] = useState('')
    const [plant_desc, setPlantDesc] = useState('')
    const [plantNameEn, setPlantNameEn] = useState('')
    const [sloc, setSloc] = useState('')
    const [sloc_description, sestSlocDescription] = useState('')
    const [product_type, setProductType] = useState('')
    const [product_unit, setProductunit] = useState('')
    const [product_type_desc, setProductTypeDesc] = useState('')
    const [material_number, setMaterialNumber] = useState('')
    const [product_name, setProductName] = useState('')
    const [productNameEn, setProductNameEn] = useState('')
    const [product_spec, setProductSpec] = useState('')
    const [fixed_price, setFixedPrice] = useState(0)
    const [fixed_quantum, setfixedQuantum] = useState(0)
    const [price, setPrice] = useState(0)
    const [quantum, setQuantum] = useState(0)
    const [shipping_tolerance_contract, setShippingToleranceContract] = useState(0)
    const [notes, setNotes] = useState('')

    useEffect(() => {
        if (props.show) {
            getPlantList(props.item?.material_number || '')
            getMaterialGroupList()
            getProductList(props.item?.plant || '', props.item?.sales_org_code, props.item?.product_type)
        }
    }, [props.show])

    useEffect(() => {
        setPlant(props.item?.plant)
        setPlantDesc(props.item?.plant_desc)
        setSloc(props.item?.sloc)
        sestSlocDescription(props.item?.sloc_description)
        setProductType(props.item?.product_type)
        setProductunit(props.item?.unit)
        setProductTypeDesc(props.item?.product_type_desc)
        setMaterialNumber(props.item?.material_number)
        setProductName(props.item?.product_name)
        setProductSpec(props.item?.product_spec)
        setFixedPrice(props.item?.fixed_price)
        setfixedQuantum(props.item?.fixed_quantum)
        setShippingToleranceContract(props.item?.shipping_tolerance_contract)
        setNotes(props.item?.notes)
        setPrice(props.item?.price)
        setQuantum(props.item?.quantum)
        setSector(props.item?.sector_id)
        setPlantNameEn(props.item?.plant_name_en)
        setProductNameEn(props.item?.material_desc_en)
    }, [props.item])

    const getPlantList = async (material_number: string) => {
        setLoading(true)
        await getPlantV2(props.item.sales_org_code, material_number).then((res) => {
            let temparray: any[] = [{ value: 0 + '|||', label: t('Pilih-plant') }]
            res.data.data.forEach((item: any) => {
                temparray.push({
                    value: item.plant + '|||' + item.plant_name,
                    label: item.plant + ' - ' + item.plant_name,
                })
            })
            setPlants(temparray)
        })
        setLoading(false)
    }

    const getSLocList = async () => {
        await getSloc(plant, i18next.language, material_number, fixed_quantum, product_type)
            .then((res) => {
                setSlocs(res.data.data)
            })
            .catch((err) => {
                swal({
                    title: t(err.response.data.message),
                    icon: 'error',
                })
                setSlocs([])
            })
    }

    const getMaterialGroupList = async () => {
        await getMaterialGroup()
            .then((res) => {
                setProductTypes(res.data.data)
            })
    }

    const getProductList = async (plant: any, sales_org: any, product_type: any) => {
        await getListMaterialAll(plant, '', sales_org, product_type).then((res) => {
            let tempArray: any[] = [{ value: 0 + '|||', label: t('Pilih-productName') }]
            res.data.data.forEach((item: any) => {
                if (item.material_number != 0) {
                    tempArray.push({
                        value: item.material_description + '|||' + item.material_number,
                        label: parseInt(item.material_number) + " - " + item.material_description,
                    })
                }
            })
            setProducts(tempArray)
        })
    }

    const setMultipleState = (value: any, state1: any, state2: any) => {
        const temp = value.split('|||')
        state1(temp[0])
        state2(temp[1])
    }

    useEffect(() => {
        if (plant) {
            getSLocList()
            getProductList(plant, props.item?.sales_org_code, product_type)
        }
    }, [plant])

    useEffect(() => {
        if (material_number) {
            getPlantList(material_number)
        }
    }, [material_number])

    const productTypeChanged = (value: string) => {
        const temp = value.split('|||')
        setProductType(temp[0])
        setProductTypeDesc(temp[1])
        getProductList(plant, props.item?.sales_org_code, temp[0])
    }

    const validate = (): string => {
        if (plant == '' || plant == '0') return t('isi') + t('sub-order-gudang')
        else if (sloc == '' || sloc == '0') return t('isi') + t('sloc')
        else if (product_type_desc != 'KANTONG/SACK' && (price == 0 || isNaN(price)))
            return t('isi') + t('harga')
        else if (shipping_tolerance_contract < 0) return t('shipping tolerance tidak boleh minus')
        else if (shipping_tolerance_contract > 100) return t('Shipping tolerance melebihi 100%')
        else if (!quantum) return t('CREATE_CONTRACT.VALIDATE.EDIT_QUANTUM')
        else if (!props.item?.is_new_item && (quantum > (props.item?.fixed_quantum - (props.item?.quantum_contract || 0))))
            return t('CREATE_CONTRACT.VALIDATE.EDIT_CONTRACT')
        else if (sector == '3' && (!plantNameEn || plantNameEn == '')) return t('isi') + t('sub-order-gudang') + ' (EN)'
        else if (sector == '3' && (!productNameEn || productNameEn == '')) return t('isi') + t('sub-order-produk') + ' (EN)'
        else return ''
    }

    const editItem = () => {
        const checkValidate = validate()
        if (!checkValidate) {
            props.onEdit({
                ...props.item,
                plant,
                plant_desc,
                sloc,
                sloc_description,
                product_type,
                product_type_desc,
                product_name,
                material_number,
                product_spec,
                shipping_tolerance_contract,
                notes,
                price,
                quantum,
                material_desc_en: productNameEn,
                plant_desc_en: plantNameEn,
            })
            props.onCloseModal()
        } else {
            swal({
                title: checkValidate,
                icon: 'error',
            })
        }
    }

    return (
        <div>
            <Modal
                show={props.show}
                onHide={props.onCloseModal}
                centered
                backdrop='static'
                keyboard={false}
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t('Edit')} Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? (
                        <div className='d-flex justify-content-center'>
                            <Spinner animation='border' variant='primary' />
                        </div>
                    ) : (
                        <>
                            <Form.Group className='mb-3' controlId='formBasicEmail'>
                                <Form.Label>{t('sub-order-gudang')}</Form.Label>
                                <Select
                                    placeholder={t('pilih') + ' ' + t('sub-order-gudang')}
                                    onChange={(e: any) => {
                                        setMultipleState(e.value, setPlant, setPlantDesc)
                                        setSloc('')
                                        sestSlocDescription('')
                                    }}
                                    options={plants}
                                    defaultValue={plants[plants.findIndex((x: any) => x.value == `${plant}|||${plant_desc}`)]}
                                />
                            </Form.Group>
                            { sector == '3' && <Form.Group className='mb-3' controlId='formBasicEmail'>
                                <Form.Label>{t('sub-order-gudang')} (EN)</Form.Label>
                                <Form.Control
                                    aria-label='Default select example'
                                    value={plantNameEn}
                                    style={{ height: '40px' }}
                                    onChange={(e: any) => {
                                        setPlantNameEn(e.target.value)
                                    }}
                                />
                            </Form.Group> }
                            <Form.Group className='mb-3' controlId='formBasicEmail'>
                                <Form.Label>{t('storage location')}</Form.Label>
                                <Form.Select
                                    aria-label='Default select example'
                                    onChange={(e: any) => setMultipleState(e.target.value, setSloc, sestSlocDescription)}
                                    id='sloccc'>
                                    <option value=''>
                                        {t('pilih')} {t('storage location')}
                                    </option>
                                    {slocs?.map((item: any) => {
                                        return (
                                            <>
                                                {item.sloc == sloc ? (
                                                    <option selected value={item.sloc + '|||' + item.sloc_description}>
                                                        {item.sloc + ' - ' + item.sloc_description}
                                                    </option>
                                                ) : (
                                                    <option value={item.sloc + '|||' + item.sloc_description}>
                                                        {item.sloc + ' - ' + item.sloc_description}
                                                    </option>
                                                )}
                                            </>
                                        )
                                    })}
                                </Form.Select>
                            </Form.Group>
                            {plant && (
                                <>
                                    <Form.Group className='mb-3' controlId='formBasicEmail'>
                                        <Form.Label>{t('kontrak-jenis')}</Form.Label>
                                        <Form.Select
                                            aria-label='Default select example'
                                            onChange={(e: any) => productTypeChanged(e.target.value)}
                                        >
                                            <option value=''>
                                                {t('pilih')} {t('kontrak-jenis')}
                                            </option>
                                            {product_types?.map((item: any) => {
                                                return (
                                                    <>
                                                        {item.material_group == product_type ? (
                                                            <option
                                                                selected
                                                                value={item.material_group + '|||' + item.material_group_desc}
                                                            >
                                                                {item.material_group + ' - ' + item.material_group_desc}
                                                            </option>
                                                        ) : (
                                                            <option value={item.material_group + '|||' + item.material_group_desc}>
                                                                {item.material_group + ' - ' + item.material_group_desc}
                                                            </option>
                                                        )}
                                                    </>
                                                )
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className='mb-3' controlId='formBasicEmail'>
                                        <Form.Label>{t('sub-order-produk')}</Form.Label>
                                        <Select
                                            key={products + product_type_desc}

                                            placeholder={t('pilih') + ' ' + t('sub-order-produk')}
                                            onChange={(e: any) => setMultipleState(e.value, setProductName, setMaterialNumber)}
                                            options={products}
                                            value={products[products.findIndex((x: any) => x.value == product_name + "|||" + material_number)]}
                                        />
                                    </Form.Group>
                                    { sector == '3' && <Form.Group className='mb-3' controlId='formBasicEmail'>
                                        <Form.Label>{t('sub-order-produk')} (EN)</Form.Label>
                                        <Form.Control
                                            aria-label='Default select example'
                                            as='textarea'
                                            value={productNameEn}
                                            style={{ height: '40px' }}
                                            onChange={(e: any) => {
                                                setProductNameEn(e.target.value)
                                            }}
                                        />
                                    </Form.Group> }

                                    <Form.Group className='mb-3' controlId='formBasicEmail'>
                                        <Form.Label>{t('sub-order-spek')}</Form.Label>
                                        <div>
                                            <RichText
                                                containerClassName='mt-4'
                                                content={product_spec}
                                                onUpdate={({ editor }) => {
                                                    setProductSpec(editor.getHTML())
                                                }}
                                            >
                                                &nbsp;
                                            </RichText>
                                        </div>
                                    </Form.Group>

                                    <Form.Group className='mb-3' controlId='formBasicEmail'>
                                        <Form.Label>{t('kontrak-harga')}</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text id='basic-addon1'>
                                                {props.item?.sector_id != 3 ? 'Rp' : 'USD'}
                                            </InputGroup.Text>
                                            <CurrencyInput
                                                id='rp'
                                                placeholder={t('kontrak-harga')}
                                                className='form-control form-control-sm'
                                                defaultValue={price || fixed_price}
                                                decimalSeparator={i18next.language === 'en' ? '.' : ','}
                                                groupSeparator={i18next.language === 'en' ? ',' : '.'}
                                                decimalsLimit={props.item?.sector_id != 3 ? -1 : 2}
                                                onValueChange={(value: any) => {
                                                    setPrice(parseFloat(value?.replace(/,/g, '.')))
                                                }}
                                            />
                                        </InputGroup>
                                    </Form.Group>

                                    <Row>
                                        <Col md='6'>
                                            <Form.Group className='mb-3' controlId='formBasicEmail'>
                                                <Form.Label>
                                                    {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.TOTAL_QUANTUM_LABEL')}
                                                </Form.Label>
                                                <Form.Control
                                                    aria-label='Default select example'
                                                    defaultValue={props.item?.quantum_contract || ''}
                                                    disabled
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md='6'>
                                            <Form.Group className='mb-3' controlId='formBasicEmail'>
                                                <Form.Label>{t('sisaquantum')}</Form.Label>
                                                <Form.Control
                                                    aria-label='Default select example'
                                                    defaultValue={(props.item?.fixed_quantum - (props.item?.quantum_contract || 0))}
                                                    disabled
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md='6'>
                                            <Form.Group className='mb-3'>
                                                <Form.Label>
                                                    {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.QUANTUM_SIP_LABEL')}
                                                </Form.Label>
                                                <InputGroup>
                                                    <CurrencyInput
                                                        disabled
                                                        className='form-control form-control-sm'
                                                        defaultValue={props.item?.is_new ? '' : fixed_quantum}
                                                        decimalSeparator={i18next.language === 'en' ? '.' : ','}
                                                        groupSeparator={i18next.language === 'en' ? ',' : '.'}
                                                        decimalsLimit={3}
                                                    />
                                                    <InputGroup.Text>Ton</InputGroup.Text>
                                                </InputGroup>
                                            </Form.Group>
                                        </Col>

                                        <Col md='6'>
                                            <Form.Group className='mb-3'>
                                                <Form.Label>
                                                    {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.TOLERANCE_SIP_LABEL')}
                                                </Form.Label>
                                                <InputGroup>
                                                    <CurrencyInput
                                                        disabled
                                                        className='form-control form-control-sm'
                                                        defaultValue={
                                                            props.item?.is_new ? '' : props.item?.shipping_tolerance ?? ''
                                                        }
                                                        decimalSeparator={i18next.language === 'en' ? '.' : ','}
                                                        groupSeparator={i18next.language === 'en' ? ',' : '.'}
                                                        decimalsLimit={3}
                                                    />
                                                    <InputGroup.Text>%</InputGroup.Text>
                                                </InputGroup>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md='6'>
                                            <Form.Group className='mb-3' controlId='formBasicEmail'>
                                                <Form.Label>
                                                    {product_type == '8105'
                                                        ? t('sack')
                                                        : t('CREATE_CONTRACT.EDIT_ITEM_MODAL.SUBMISSION_QUANTUM_LABEL')}
                                                </Form.Label>
                                                <InputGroup>
                                                    <CurrencyInput
                                                        id='ton'
                                                        placeholder={
                                                            product_type == '8105'
                                                                ? t('sack')
                                                                : t('CREATE_CONTRACT.EDIT_ITEM_MODAL.SUBMISSION_QUANTUM_LABEL')
                                                        }
                                                        className='form-control form-control-sm'
                                                        defaultValue={quantum || fixed_quantum}
                                                        decimalSeparator={i18next.language === 'en' ? '.' : ','}
                                                        groupSeparator={i18next.language === 'en' ? ',' : '.'}
                                                        decimalsLimit={3}
                                                        onValueChange={(value: any) => {
                                                            setQuantum(parseFloat(value?.replace(/,/g, '.')))
                                                        }}
                                                    />
                                                    <InputGroup.Text id='basic-addon1'>
                                                        {product_type == '8105' ? product_unit : 'Ton'}
                                                    </InputGroup.Text>
                                                </InputGroup>
                                            </Form.Group>
                                        </Col>
                                        <Col md='6'>
                                            <Form.Group className='mb-3'>
                                                <Form.Label>
                                                    {t('CREATE_CONTRACT.EDIT_ITEM_MODAL.SHIPPING_TOLERANCE_LABEL')}
                                                </Form.Label>
                                                <InputGroup>
                                                    <CurrencyInput
                                                        className='form-control form-control-sm'
                                                        value={shipping_tolerance_contract || '0'}
                                                        decimalSeparator={i18next.language === 'en' ? '.' : ','}
                                                        groupSeparator={i18next.language === 'en' ? ',' : '.'}
                                                        decimalsLimit={3}
                                                        onValueChange={(v: any) => {
                                                            setShippingToleranceContract(parseFloat(v?.replace(/,/g, '.')))
                                                        }}
                                                    />
                                                    <InputGroup.Text>%</InputGroup.Text>
                                                </InputGroup>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Form.Group className='mb-3' controlId='formBasicEmail'>
                                        <Form.Label>{t('CREATE_CONTRACT.EDIT_ITEM_MODAL.NOTE_LABEL')}</Form.Label>
                                        <Form.Control
                                            aria-label='Default select example'
                                            as='textarea'
                                            value={notes}
                                            style={{ height: '40px' }}
                                            onChange={(e: any) => setNotes(e.target.value)}
                                        />
                                    </Form.Group>
                                </>
                            )}
                            <div className='d-flex justify-content-end mt-5'>
                                <Button onClick={editItem}>{t('Save')}</Button>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    )
}